import httpClient from '@/lib/httpClient'
import { useQuery } from '@tanstack/react-query'

export interface AuthProviders {
  xero: { enabled: boolean }
}

/**
 * Which sign-in providers are switched on (backend env switches, e.g.
 * XERO_SSO_ENABLED). Public — read by the login and register pages.
 */
export default function useAuthProviders() {
  return useQuery<AuthProviders>({
    queryKey: ['auth-providers'],
    queryFn: async () => {
      const response = await httpClient.get('auth/providers')
      return response.data
    },
    staleTime: 5 * 60 * 1000,
  })
}
